import { PageHero } from "@/components/ui-kit";
import { Reveal } from "@/lib/motion";
import { useSeo } from "@/lib/useSeo";
import { BUSINESS } from "@/lib/config";

const PRIVACY = [
  ["Introduction", `${BUSINESS.name} ("we", "us") respects your privacy. This policy explains how we collect, use and protect your personal information when you interact with our website and services.`],
  ["Information We Collect", "We collect details you voluntarily provide through our enquiry and consultation forms — including your name, phone number, email, location, budget and project requirements — along with limited analytics data such as UTM parameters and page interactions."],
  ["How We Use Your Information", "Your information is used solely to respond to enquiries, schedule consultations, deliver our design and execution services, and improve your experience. We never sell your data to third parties."],
  ["Data Storage & Security", "Submissions are stored securely and access is restricted to authorised members of our team. We apply reasonable technical and organisational measures to protect your data."],
  ["Your Rights", "You may request access to, correction of, or deletion of your personal data at any time by contacting us at " + BUSINESS.email + "."],
  ["Cookies & Analytics", "We may use cookies and analytics to understand how visitors use our site. You can control cookies through your browser settings."],
  ["Contact", `For any privacy-related queries, reach us at ${BUSINESS.email} or ${BUSINESS.phone}.`],
];

const TERMS = [
  ["Acceptance of Terms", `By accessing this website, you agree to these Terms & Conditions. If you do not agree, please discontinue use of the site.`],
  ["Services", "All designs, estimates and BOQs shared are indicative until a formal agreement is signed. Final scope, pricing and timelines are confirmed in your project contract."],
  ["Intellectual Property", `All content, imagery, designs and branding on this website are the property of ${BUSINESS.name} and may not be reproduced without written permission.`],
  ["Project Engagement", "Any engagement for design or execution services is governed by a separate written agreement detailing scope, payment milestones, timelines and warranty terms."],
  ["Warranty", "Warranty coverage, where applicable, is defined in your project agreement and applies to specified products and workmanship."],
  ["Limitation of Liability", "We are not liable for indirect or consequential damages arising from use of this website. Project-related liabilities are governed by your signed agreement."],
  ["Governing Law", "These terms are governed by the laws of India, with jurisdiction in the courts of Kolkata, West Bengal."],
];

export default function Legal({ kind }) {
  const isPrivacy = kind === "privacy";
  const data = isPrivacy ? PRIVACY : TERMS;
  const title = isPrivacy ? "Privacy Policy" : "Terms & Conditions";
  useSeo({ title, description: `${title} for ${BUSINESS.name}.` });

  return (
    <div data-testid={`legal-${kind}-page`}>
      <PageHero overline="Legal" title={title} sub={`Last updated ${new Date().getFullYear()}. Please read carefully.`} />
      <section className="mx-auto max-w-[820px] px-6 md:px-10 pb-24">
        {data.map(([h, b], i) => (
          <Reveal key={h} delay={i * 0.03} className="mb-10">
            <h2 className="font-display text-2xl md:text-3xl mb-3">{i + 1}. {h}</h2>
            <p className="text-ink/75 leading-relaxed">{b}</p>
          </Reveal>
        ))}
      </section>
    </div>
  );
}
